import { useEffect } from 'react'
import { getAppBaseUrl } from '../config/surface'

/**
 * VISTOERA_HOME_IS_CANVAS_V1 (VistoeraTASK-00264 §一/§二/§九) — the
 * Marketing Surface root (`/`) no longer renders the Landing Page
 * directly. Product direction: "第一阶段不再继续强化 Marketing Landing
 * Page 作为用户进入产品前的必经页面，而是让用户访问 Vistoera 的主入口时
 * 尽快直接进入 Canvas."
 *
 * Full-page (cross-origin) redirect to the SaaS App Surface's own root —
 * NOT a React Router `<Navigate>` (that only handles same-router in-app
 * paths; Marketing and App are two different registrable origins in real
 * Preview/Production, see `config/surface.ts`'s module docstring). The
 * App Surface's own root (`saas/RootEntryRedirect.tsx`) already resolves
 * auth state and lands the user on Canvas Home (authenticated) or
 * `/login` (not) — this component's only job is the one hop to get
 * there, reusing the exact same `getAppBaseUrl()` resolver every
 * Marketing CTA already goes through (never a second hardcoded host —
 * enforced by `backend/tests/test_frontend_navigation_contract.py`).
 *
 * The Landing Page itself is fully preserved, code untouched, still
 * reachable at `/product` (see `MarketingApp.tsx`) — spec §十 "不要直接
 * 删除 Marketing 页面".
 */
export default function MarketingRootRedirect() {
  useEffect(() => {
    window.location.replace(getAppBaseUrl())
  }, [])
  return null
}
